module.exports = __webpack_public_path__ + "img/index-chat.fa95c382.png";